import { FormattedMessage } from 'react-intl';
import FormattedDateOrNotSet from './FormattedDateOrNotSet';

interface Props {
  start: string | null;
  end: string | null;
}

export default function DateRange({ start, end }: Props) {
  return (
    <>
      <FormattedDateOrNotSet value={start} fallbackId="common.notAvailable" />{' '}
      <FormattedMessage id="common.and" />{' '}
      <FormattedDateOrNotSet value={end} fallbackId="common.notAvailable" />
    </>
  );
}
